const formatTitleAsUrl = ({ title, id }) => {
  const array = title.split(' ');
  const urlPath = array.join('-').toLowerCase().replace(/ /g, '-');
  const url = `${urlPath}_${id}`.replace(/'|’/g, '').normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  return encodeURIComponent(url);
};

export default formatTitleAsUrl;
